import { Link } from 'react-router-dom';

const columns = [
  {
    title: '内容栏目',
    links: [
      { to: '/comics?cat=daily', label: '日常搞笑' },
      { to: '/comics?cat=office', label: '职场摸鱼' },
      { to: '/comics?cat=bedtime', label: '睡前治愈' },
      { to: '/comics?cat=commute', label: '通勤解闷' },
    ],
  },
  {
    title: '站点导航',
    links: [
      { to: '/about', label: '关于我们' },
      { to: '/faq', label: '常见问题' },
      { to: '/contact', label: '联系我们' },
      { to: '/comics', label: '全部漫画' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/80 border-t border-background-300/60">
      <div className="mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4 md:gap-6">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-emotion-laugh-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-950">歪歪漫画</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              韩国歪歪漫画专注短篇搞笑日常内容，适合摸鱼、睡前、通勤等碎片时间快看。
              持续更新的减压漫画，热门短篇分类齐全，随时随地一刷就停不下来。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              {['抖音', '小红书', '微博', 'B站'].map((s) => (
                <a
                  key={s}
                  href="#"
                  rel="nofollow"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                  aria-label={s}
                >
                  <i
                    className={
                      s === '抖音'
                        ? 'ri-music-2-line'
                        : s === '小红书'
                          ? 'ri-heart-line'
                          : s === '微博'
                            ? 'ri-weibo-line'
                            : 'ri-tv-line'
                    }
                  ></i>
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-lg text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 韩国歪歪漫画 · 轻松追更每一天
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-600">
            <Link to="/about" className="hover:text-primary-600 whitespace-nowrap">内容原则</Link>
            <Link to="/faq" className="hover:text-primary-600 whitespace-nowrap">追更帮助</Link>
            <Link to="/contact" className="hover:text-primary-600 whitespace-nowrap">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}